function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import SocialActivity from "./SocialActivity";
import isFunction from "lodash/isFunction";
var _React_Component;
var SocialActivities = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(SocialActivities, _superClass);
    var _super = _createSuper(SocialActivities);
    function SocialActivities() {
        _classCallCheck(this, SocialActivities);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderActivity = function(activity) {
            var deleted = !!activity.deleted_at;
            var actions = deleted ? [] : activity._permissions.filter(function(permission) {
                return permission !== "show";
            });
            return /*#__PURE__*/ React.createElement(SocialActivity, {
                key: activity.id,
                activity: activity,
                deleted: deleted,
                isEditable: actions.includes("update"),
                onEdit: _this.handleOnEdit,
                onDelete: _this.handleOnDelete,
                fetchActivity: _this.props.fetchActivity,
                actions: actions,
                session: _this.props.session
            });
        };
        _this.handleOnEdit = function(activity) {
            if (isFunction(_this.props.onEdit)) {
                _this.props.onEdit(activity);
            }
        };
        _this.handleOnDelete = function(activity) {
            if (isFunction(_this.props.onDelete)) {
                _this.props.onDelete(activity);
            }
        };
        return _this;
    }
    var _proto = SocialActivities.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("ul", {
            className: "social-activities"
        }, this.props.activities.filter(function(act) {
            return act.deleted_at || act._permissions.includes("show");
        }).map(this.renderActivity));
    };
    return SocialActivities;
}(_React_Component = React.Component);
SocialActivities.displayName = "SocialActivities";
export default SocialActivities;
